import React, { useContext, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { P1P2Contenxt } from "../..";
import { Spin } from "antd";

const options = ({ type }) => ({
  title: {
    text: `Overal ${type} site status`,
    margin: 50,
    style: { fontSize: "1.5rem", fontWeight: "bold" },
  },
  chart: {
    type: "column",
    style: {
      fontFamily: `Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI",
        "Helvetica Neue", Arial, "Noto Sans", sans-serif,
        "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`,
    },
  },
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  colors: ["#2F5EC4", "#45a5f5"],
  plotOptions: {
    column: {
      stacking: "percent",
      dataLabels: {
        enabled: true,
        color:
          (Highcharts.theme && Highcharts.theme.dataLabelsColor) || "white",
        style: {
          textShadow: "0 0 3px black, 0 0 3px black",
        },
      },
    },
  },
  yAxis: {
    min: 0,
    lineWidth: 1,
    title: {
      enabled: false,
    },
    labels: {
      format: "{text}%",
    },
  },
  xAxis: {
    // type: "datetime",
    type: "category",
    labels: {
      style: { fontWeight: "bold" },
    },
    lineWidth: 1,
  },
  tooltip: {
    shared: true,
  },
  series: [
    // {
    //   name: "Normal",
    //   data: [
    //     ["2G_CSSR", 5],
    //     ["2G_DCR", 5],
    //     ["3G_CSSR_CS", 5],
    //     ["3G_DCR_CS", 5],
    //     ["3G_THR", 5],
    //     ["4G_THR", 5],
    //     ["4G_CSSR_PS", 5],
    //   ],
    // },
    // {
    //   name: "Problematic",
    //   data: [
    //     ["2G_CSSR", 5],
    //     ["2G_DCR", 5],
    //     ["3G_CSSR_CS", 5],
    //     ["3G_DCR_CS", 5],
    //     ["3G_THR", 5],
    //     ["4G_THR", 5],
    //     ["4G_CSSR_PS", 5],
    //   ],
    // },
  ],
});

const POverallChart = ({ type }) => {
  const chartRef = useRef(null);
  const wrapperRef = useRef(null);

  const { dataSource } = useContext(P1P2Contenxt);

  // const handleResize = () => {
  //   if (wrapperRef && wrapperRef.current) {
  //     if (chartRef && chartRef.current) {
  //       chartRef.current.chart.update(
  //         {
  //           chart: {
  //             width: wrapperRef.current.clientWidth - 16,
  //           },
  //         },
  //         true
  //       );
  //       // console.log("resized to: ", wrapperRef.current.clientWidth, dataset);
  //     }
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener("resize", handleResize);

  //   setTimeout(() => {
  //     window.dispatchEvent(new Event("resize"));
  //   }, 1000);

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  //   // eslint-disable-next-line
  // }, [type]);

  useEffect(() => {
    if (
      dataSource[type] &&
      !dataSource[type].loading &&
      dataSource[type].data.bar &&
      dataSource[type].data.bar.length > 0
    ) {

      dataSource[type].data.bar.forEach((s) => {
        chartRef.current.chart.addSeries(s, true);
      });
    }
  }, [dataSource, type]);

  return (
    <Spin spinning={dataSource[type].loading}>
      <div ref={wrapperRef}>
        <HighchartsReact
          ref={chartRef}
          highcharts={Highcharts}
          options={options({ type })}
        />
      </div>
    </Spin>
  );
};

export default POverallChart;
